import React from 'react'
import { Col, Row } from 'react-bootstrap'

export const ThankYou = ({ message }) => {
  return (
    <>
      <div className="container pt-5 pb-2">
        <div className="custom-template" >
          <Row>
            <Col sm={8} md={8} lg={10} xl={10} >
              <img
                width={270}
                height={270}
                alt='poonalogo.jpg'
                src="./poonalogo.jpg"
                className="img-fluid"
              ></img>
            </Col>
          </Row>
          <div className="custom-template-thankyou text-center">{message}</div>
        </div>
      </div>
    </>
  )
}
